import React from 'react';
import { useQuery } from '@apollo/react-hooks';

import './desktop-product-detail-review-preview-style.scss';

import { Loading } from '@atoms';
import ProductListTitle from '@src/componentsNew/ProductListTitle/ProductListTitle';
import DesktopReviewListItem from '@src/componentsNew/ListItem/ReviewListItem/DesktopReviewListItem';

import { OrderDirection, ReviewSortField } from '__generated__/globalTypes';
import { REVIEWS } from '@molecules/ReviewList/queries';
import { reviews, reviewsVariables } from '@molecules/ReviewList/__generated__/reviews';

export interface IProps {
  productId: string;
}
const reviewsToShow = 3;

const DesktopProductDetailReviewPreview = ({ productId }: IProps) => {
  const initialVariables: reviewsVariables = {
    product: productId,
    first: reviewsToShow,
    sortBy: {
      field: ReviewSortField.RATING,
      direction: OrderDirection.DESC,
    },
  };

  const { data: reviewsData, loading, refetch } = useQuery<reviews>(REVIEWS, {
    variables: initialVariables,
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      const reviews = data.reviews;
    },
  });

  const goTotalReviewSection = () => {
    const totalReviewSection = document.getElementById('desktop-product-detail-review-area');

    if (totalReviewSection) {
      const elementPosition = totalReviewSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition - 65;

      window.scrollBy({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  if (loading) {
    return <Loading />;
  }

  return reviewsData?.reviews ? (
    <div id="desktop-product-detail-review-preview-area">
      <ProductListTitle
        title="Maccaronies Said"
        typoVariant="h8"
        typoComponent="h6"
        typoColor="#212121"
        isShowLine={true}
        isShowRightBtn={true}
        rightBtnSize="small"
        rightBtnColor="#666666"
        rightBtnClick={goTotalReviewSection}
        isShowArrow={true}
      />

      <div className="product-detail-review-preview-item-wrapper">
        {reviewsData?.reviews?.edges.map((edge) => (
          <DesktopReviewListItem key={edge.node.id} review={edge.node} isPreview={true} refetch={refetch} />
        ))}
      </div>
    </div>
  ) : null;
};

export default DesktopProductDetailReviewPreview;
